var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.controllers},scopedSlots:_vm._u([{key:"item.Imei",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'controller', params: { imai: item.Imei }}}},[_vm._v(" "+_vm._s(item.Imei)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }